// src/components/MenuPages.js
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const MenuPages = () => {
  const navigate = useNavigate();
  const location = useLocation(); 

  const buttonStyle = (path) => ({
    padding: "5px 10px",
    marginLeft: "2px",
    cursor: "pointer",
    borderRadius: "4px",
    border: "1px solid #8abff3",
    backgroundColor: location.pathname === path ? "#4d83b9" : "#fff",
    color: location.pathname === path ? "#fff" : "#74a7da",
    fontWeight: "bold",
    transition: "all 0.3s"
  });

  return (
    <div style={{ textAlign: "right", marginBottom: "10px", padding: "0px" }}>
      <button 
        style={buttonStyle("/")} 
        onClick={() => navigate("/")}
      >
        Painel Casa Legal
      </button>
      <button
        style={buttonStyle("/progestao")}
        onClick={() => navigate("/progestao")}
      >
        ProGestão
      </button>
    </div>
  );
};

export default MenuPages;